import { Injectable } from '@angular/core';
import {Http, RequestOptions, Response, ResponseContentType, URLSearchParams} from '@angular/http';
import { Observable } from 'rxjs/Rx';
import {Archive} from './archive.model';
import {Fichier} from './fichier.model';
import {StatusArchivage} from './statusArchivage.model';
import {DateUtils} from 'ng-jhipster';

@Injectable()
export class JhiArchiveService {

    private static creeStatusArchivage (res): StatusArchivage {
        let status: StatusArchivage = new StatusArchivage();
        status.enCours = res.json().enCours;
        if ( res.json().dateDeLancement != null) {
            status.dateDeLancement = new Date(res.json().dateDeLancement) ;
        }
        return status ;
    }


    private static creeArchive (res): Archive {
        let archive: Archive = new Archive();
        archive.label = res.json().label;
        archive.fichier = Fichier.creeFichier(res.json().fichier);
        archive.annee = res.json().annee;
        archive.anneeCourante = res.json().anneeCourante;
        return archive ;
    }

    constructor(private http: Http, private dateUtils: DateUtils) {
    }

    get(annee: String): Observable<Archive> {
        return this.http.get('api/archive/' + annee).map((res: Response) => {
            return JhiArchiveService.creeArchive(res) ;
        });
    }

    archiveAnneecourante(): Observable<Response> {
        return this.http.put('api/archive/anneecourante', new Archive()).map((res: Response) => {
            return res ;
        });
    }

    getStatusArchivage(): Observable<StatusArchivage> {
        return this.http.get('api/archivestatus/', new StatusArchivage()).map((res: Response) => {
            return JhiArchiveService.creeStatusArchivage(res) ;
        });
    }


    public getFile(file: Fichier): Observable<any> {
        let params = new URLSearchParams();
        params.set('nomarchive', file.nom);
        let options = new RequestOptions({responseType: ResponseContentType.Blob as ResponseContentType.Json});

        return this.http.put('api/archive/fichier', file.nom, options).map(
            (res: Response) => {
                let name = file.nom.toLowerCase();
                if (name.endsWith('.pdf')) {
                    return new Blob([res.json()], {type: 'application/pdf'});
                } else if (name.endsWith('.jpg') || name.endsWith('.jpeg')) {
                    return new Blob([res.json()], {type: 'image/jpeg'});
                } else if (name.endsWith('.docx') || name.endsWith('.doc')) {
                    return new Blob([res.json()], {type: 'application/msword'});
                } else if (name.endsWith('.png')) {
                    return new Blob([res.json()], {type: 'image/png'});
                }
            });
    }


    deleteRepertoire(repertoire: Fichier)  {
        let params = new URLSearchParams();
        params.set('nomRepertoire', repertoire.nom);
        return this.http.put('api/archive/delete', {}, { search: params }).map(
            (res: Response) => {});

    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/archive/archive.service.ts